import React from 'react'
import { isMobile } from 'react-device-detect'

import { CompactTable } from '@table-library/react-table-library/compact'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'

const UserPlansAndActiveSubscriptionsTable = ({ data = [], columns = [] }) => {

  const tableData = {
    nodes: data,
  }

  const tableTheme = useTheme(
    [
      getTheme(),
      {
        Table: `
        --data-table-library_grid-template-columns: 
          minmax(16rem, 1fr) // displayName
          minmax(5rem, 1fr) // Subscription Status
          minmax(10rem, 1fr) // Price
          minmax(7rem, 1fr) // Billing
          minmax(12rem, 1fr) // Next Renewal On
          minmax(12rem, 1fr) // Next Allocation On
          minmax(4.5rem, 1fr) // Action
          minmax(7rem, 1fr) // Customized
          minmax(4.5rem, 1fr); // Type

          grid-template-rows: max-content

          height: 100%;
        `,
        HeaderCell: `
        height: fit-content;
      `,
        Row: `
          font-size:14px;
        `
      }
    ]
  )

  return (
    <div className='plan-subs-list-table'>
      <CompactTable
        columns={columns}
        data={tableData}
        layout={{
          fixedHeader: true,
          horizontalScroll: !isMobile,
          custom: true
        }}
        theme={tableTheme}
      />
    </div>
  )
}

export default UserPlansAndActiveSubscriptionsTable